export default __webpack_public_path__ + "static/38-5845065bdd2e2a164f7db45c9973680e.gif";